export function getLocale() {
  const locale = navigator.language.split("-")[0];
  log.app("locale", locale);
  return locale;
}
export function getlanguageCode() {
  const locale = navigator.language;
  return locale;
}
